const Skeleton = ({ className = "" }) => <div className={`skeleton-shimmer ${className.includes("rounded") ? "" : "rounded-md"} ${className}`} />;

const Rows = ({ n = 6 }) => (
  <div className="space-y-2">
    {Array.from({ length: n }, (_, i) => (
      <div key={i} className="flex items-center gap-3 rounded-2xl bg-white ring-1 ring-zinc-100 p-3">
        <Skeleton className="w-10 h-10 rounded-xl" />
        <div className="flex-1 space-y-2"><Skeleton className="h-3.5 w-2/3" /><Skeleton className="h-2.5 w-1/3" /></div>
        <Skeleton className="w-16 h-6 rounded-full" />
      </div>
    ))}
  </div>
);

const Grid = () => (
  <div className="space-y-4">
    <div className="flex gap-3"><Skeleton className="h-6 w-48" /><Skeleton className="h-6 w-10" /></div>
    <div className="grid gap-2 sm:grid-cols-3">{[0, 1, 2].map((i) => <Skeleton key={i} className="h-14 rounded-xl" />)}</div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">{[0, 1, 2, 3].map((i) => <Skeleton key={i} className="h-56 md:h-72 rounded-2xl" />)}</div>
  </div>
);

// Pulsing outline of the content that is about to appear; `label` stays for screen readers.
export const PageSkeleton = ({ variant = "list", label = "Ładowanie…", rows }) => (
  <div data-testid="page-skeleton" role="status" aria-live="polite" className="p-3 md:p-6 skeleton-enter">
    <span className="sr-only">{label}</span>
    {variant === "grid" ? <Grid /> : <><Skeleton className="h-7 w-56 mb-4" /><Rows n={rows} /></>}
  </div>
);
